import React, { Suspense } from "react";
import { Route, Switch } from "react-router-dom";
import { CSSTransition } from "react-transition-group";
import { TransitionContainer } from "./App.styles";
import APP_ROUTES from "./routes.jsx";

import "./route-transitions.css";

const routeWrapper = (PageComponent, PageSkeletonComponent) => (props) => (
  <Suspense fallback={<div>Loading...</div>}>
    <PageComponent {...props} />
  </Suspense>
);

const App = () => (
  <Route
    render={({ location }) => (
      <TransitionContainer id="app-transition-container">
        <CSSTransition key={location.key} classNames="fade" timeout={300}>
          <Switch location={location}>
            {APP_ROUTES.map(({ path, component, title, subtitle }) => (
              <Route
                exact
                key={path}
                path={path}
                component={routeWrapper(component)}
              />
            ))}
          </Switch>
        </CSSTransition>
      </TransitionContainer>
    )}
  />
);

export default App;
